import { useTheme as useThemeWithoutDefault } from '@material-ui/styles';
import defaultTheme from './defaultTheme';
export default function useTheme() {
  return useThemeWithoutDefault() || defaultTheme;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/styles/useTheme.js
// module id = 306
// module chunks = 0